import axios from "axios";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { setProfileData } from "../Redux/Actions/TechAppAction";
import lang from "../Constant/lang.json";

const useHttp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // let platform;
  // if (window.matchMedia("(display-mode: standalone)").matches) {
  //   platform = "pwa";
  // } else {
  //   platform = "web";
  // }

  const HttpService = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
      Accept: "application/json",
      "app-type": "7",
    },
  });

  HttpService.interceptors.response.use(
    (response) => response,
    async ({ error, response }) => {
      if (response.status === 401) {
        dispatch(setProfileData(null));
        localStorage.removeItem("token");
        localStorage.removeItem("auth_from_admin");
        window.location.replace("/");
        toast.error(lang.YOU_ARE_LOGGED_OUT);
      } else if (response?.data?.errors) {
        if (response?.data?.errors) {
          toast.error(response?.data?.errors[0].detail);
        }
      } else if (response.status === 404) {
        toast.error(lang.REQUEST_NOT_FOUND);
      } else {
        toast.error(lang.API_500_ERROR_MESSAGE);
      }
    }
  );

  const TicketHttpService = axios.create({
    baseURL: process.env.REACT_APP_TICKET_BASE_URL,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
      Accept: "application/json",
      "app-type": "7",
    },
  });

  TicketHttpService.interceptors.response.use(
    (response) => response,
    async ({ error, response }) => {
      if (response.status === 401) {
        dispatch(setProfileData(null));
        localStorage.removeItem("token");
        localStorage.removeItem("auth_from_admin");
        navigate("/");
        toast.error(response?.data?.message);
      } else {
        if (response?.data?.message) {
          toast.error(response?.data?.message);
        } else {
          toast.error(lang.API_500_ERROR_MESSAGE);
        }
      }
    }
  );

  const exports = { HttpService, TicketHttpService };
  return exports;
};
export default useHttp;
